import { AxiosResponse } from 'axios';
import { call, put, StrictEffect, takeLatest } from 'redux-saga/effects';
import apiRequests from 'src/utils/api';
import apiRoutes from 'src/utils/apiRoutes';
import {
  getPendingInvites,
  setPendingInvitesData,
  setPendingInvitesError,
  setPendingInvitesLoading,
} from './reducer';
import { getCurrentCustomer } from 'src/utils/localStorage';

const { get } = apiRequests;

function* getPendingInvitesSagaListener(): any {
  const customer = getCurrentCustomer();

  if (!customer) return;

  yield put(setPendingInvitesLoading());

  try {
    const res: AxiosResponse = yield call(get, apiRoutes.CUSTOMER_INVITE, {
      'filters[status][]': 'pending',
      'filters[customer.uuid][]': customer.uuid,
    });

    yield put(setPendingInvitesData(res.data));
  } catch (error) {
    yield put(setPendingInvitesError(error));
  }
}
function* pendingInvitesSaga(): Generator<StrictEffect> {
  yield takeLatest(getPendingInvites.type, getPendingInvitesSagaListener);
}

export default pendingInvitesSaga;
